var _path, _g, _path2, _g2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolygon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4013_246465)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4013_246465",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4013_246465",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7602 21.7602H-0.760193V-0.760193H21.7602V21.7602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4013_246465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7858 10.5C20.7858 16.1826 16.1826 20.7858 10.5 20.7858C4.8174 20.7858 0.214203 16.1826 0.214203 10.5C0.214203 4.8174 4.8174 0.214203 10.5 0.214203C16.1826 0.214203 20.7858 4.8174 20.7858 10.5Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4013_246465)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4013_246465",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 0.205811H0.210007V20.79H20.7942V0.205811Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4013_246465)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7245,
    height: 20.6438,
    transform: "matrix(1 0 0 -1 0.17984 20.8202)",
    fill: "white",
    fillOpacity: 0.1
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4736 12.7176L16.3842 11.0376C16.5396 10.9494 16.632 10.7814 16.632 10.605V7.245C16.632 7.0686 16.5354 6.9006 16.3842 6.8124L13.4736 5.1324C13.3182 5.0442 13.1292 5.0442 12.9738 5.1324L10.0632 6.8124C9.90781 6.9006 9.81541 7.0686 9.81541 7.245V13.251L7.77421 14.427L5.73301 13.251V10.8948L7.77421 9.7188L9.12241 10.4958V8.9166L8.02621 8.2824C7.95061 8.2404 7.86241 8.2152 7.77841 8.2152C7.69021 8.2152 7.60621 8.2362 7.53061 8.2824L4.62001 9.9624C4.46461 10.0506 4.37221 10.2186 4.37221 10.395V13.755C4.37221 13.9314 4.46881 14.0994 4.62001 14.1876L7.53061 15.8676C7.68601 15.9558 7.87501 15.9558 8.03041 15.8676L10.941 14.1876C11.0964 14.0994 11.1888 13.9314 11.1888 13.755V7.749L11.2266 7.728L13.23 6.573L15.2712 7.749V10.1052L13.23 11.2812L11.886 10.5042V12.0834L12.9822 12.7134C13.1292 12.81 13.3224 12.81 13.4736 12.7176Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_246465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolygon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polygon.7a31a0424123c781fb153e324d1c4eca.svg";